import styled from 'styled-components'

import {typography, colour, spacing} from '../../theme/index'

export const TopicText = styled.p`
  font-family: ${typography.fontPrimary};
  margin: ${spacing.spacing1} ${spacing.spacing0};
  color: ${colour.palette.greyscale60};
  cursor: default;

  .breadcrumbs {
    margin: 0;
    overflow: hidden;
  }
  .breadcrumbs li {
    display: inline-block;
    padding-bottom: 0;
  }
  .breadcrumbChevron {
    vertical-align: bottom;
  }
`
